<template>
  <v-container fluid class="py-0">

    <!-- hero -->
    <v-row>
      <v-col
        class="pa-0">
        <v-img
          id="img-main"
          src="@/assets/img/hero-home.webp?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
          class="grey lighten-2"
          cover
          :max-height="computedPageHeight"
          :style="'height:' + computedPageHeight + 'px'">
          <v-row class="img-fade fill-height">
            <v-col>

              <!-- on image bar -->
              <v-row class="white--text max-width-1200 mx-auto">
                <app-bar-menu
                  class="px-3"
                  component="Home"
                  logo="light"
                  dark="dark">
                </app-bar-menu>
              </v-row>

              <!-- hero content -->
              <v-row align="end" class="white--text fill-height max-width-1200 mx-auto" style="padding-bottom: 44px;">
                <!-- hero ic -->
                <v-col class="pa-0 img-ic-box flip-x">
                </v-col>
                <!-- hero tender -->
                <v-col v-if="showTender" class="pa-0 img-tender-box-vekop text-right" @click="openTenderDialog('vekop')">
                  <v-btn
                    small
                    icon outlined
                    color="indigo"
                    style="background: white;"
                    @click.stop="showTender = false">×</v-btn>
                </v-col>
                <v-col v-if="showTender" class="pa-0 img-tender-box-nkfi" @click="openTenderDialog('nkfi')">
                </v-col>
                <!-- hero text -->
                <v-col class="img-text-box">
                  <div class="max-width-800 subsite-title-1 font-weight-medium mb-4 animate__animated animate__slideInLeft" style="line-height:6.2rem;">{{ $t('rubin.slogen.01') }}<br>{{ $t('rubin.slogen.02') }}</div>
                  <div class="max-width-800 mb-5 animate__animated animate__slideInLeft">{{ $t('rubin.introduction') }}</div>
                  <div class="max-width-800 mb-5 pb-5 fontsize-1rem-clamp text-uppercase animate__animated animate__slideInLeft">
                    <span class="mr-2 link-hover-effect" @click="loadPage('ItSolutions')">{{ $t('service.itSolutions.title') }}</span>
                    <span class="mx-2">|</span>
                    <span class="mx-2 link-hover-effect" @click="loadPage('EnergyManagement')">{{ $t('service.ernergyManagement.title') }}</span>
                    <span class="mx-2">|</span>
                    <span class="ml-2 link-hover-effect" @click="loadPage('Hardware')">{{ $t('service.hardware.title') }}</span>
                  </div>
                </v-col>

                <!-- rubin boxes -->
                <!-- <v-col class="img-shape-box pa-0">
                  <div class="shape animate__animated animate__fadeIn animate__delay-2s" style="height:50px;width:50px;position: relative;top: 0px;left:50px;">
                    <div class="h-100 w-100 bg-ruby" style="opacity:0.50"></div>
                  </div>
                  <div class="shape animate__animated animate__fadeIn animate__delay-2s" style="height:50px;width:50px;position: relative;top: -50px;left:100px">
                    <div class="h-100 w-100 bg-ruby" style="opacity:0.75"></div>
                  </div>
                  <div class="shape animate__animated animate__fadeIn animate__delay-2s" style="height:50px;width:50px;position: relative;top: -50px;left:0px">
                    <div class="h-100 w-100 bg-ruby" style="opacity:0.50"></div>
                  </div>
                  <div class="shape animate__animated animate__fadeIn animate__delay-2s" style="height:50px;width:50px;position: relative;top: -100px;left:50px">
                    <div class="h-100 w-100 bg-ruby" style="opacity:0.75"></div>
                  </div>
                  <div class="shape animate__animated animate__fadeIn animate__delay-2s" style="height:50px;width:50px;position: relative;top: -150px;left:100px">
                    <div class="h-100 w-100 bg-ruby" style="opacity:1.00"></div>
                  </div>
                </v-col>
                <v-col class="img-border-box pa-0">
                  <div class="border bg-white animate__animated animate__slideInRight" style="height:5px;width:100px;position: relative;top: 0px;left:50px"></div>
                  <div class="border bg-white animate__animated animate__slideInRight" style="height:5px;width:150px;position: relative;top: 45px;left:0px"></div>
                  <div class="border bg-white animate__animated animate__slideInUp" style="height:50px;width:5px;position: relative;top: 45px;left:0px"></div>
                  <div class="border bg-white animate__animated animate__slideInUp" style="height:100px;width:5px;position: relative;top: -60px;left:50px"></div>
                  <div class="border bg-white animate__animated animate__slideInUp" style="height:100px;width:5px;position: relative;top: -160px;left:100px"></div>
                </v-col> -->
              </v-row>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="pa-0">
        <Tender v-show="false" :parentOpen="dialogTender" @dialogClosed="openTenderDialog(null)"></Tender>
      </v-col>
    </v-row>
    <v-divider></v-divider>

    <v-row class="pt-8">
      <v-col class="pa-0">
        <Counter></Counter>
      </v-col>
    </v-row>

    <v-row class="pa-0">
      <v-col class="pa-0">
        <Services></Services>
      </v-col>
    </v-row>

    <v-row class="py-8">
      <v-col>
        <Partners></Partners>
      </v-col>
    </v-row>

    <v-row class="py-8 bg-ruby">
      <v-col>
        <Contact></Contact>
      </v-col>
    </v-row>

    <v-row class="py-4 bg-ic">
      <v-col>
        <Ipsum></Ipsum>
      </v-col>
    </v-row>

    <!-- <v-row class="py-4 bg-dark">
      <v-col>
        asdasdasd
      </v-col>
    </v-row> -->

  </v-container>
</template>

<script>
  import AppBarMenu from '@/components/Common/AppBar.vue';
  import DataComponentBase from '@/commons/DataComponentBase';

  import Services from '@/components/Main/Services.vue'
  import Partners from '@/components/Main/Partners.vue'
  import Counter from '@/components/Main/Counter.vue'
  import Contact from '@/components/Main/Contact.vue'
  import Tender from '@/components/Main/Tender.vue'
  import Ipsum from '@/components/Main/Ipsum.vue'

  export default {
    name: 'Home',
    metaInfo: {
      title: 'Kezdőlap',
      titleTemplate: '%s - Rubin Informatika',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Energiamérés és AI épületfelügyelet Suppport szolgáltatás, teljesítménylekötés Távfelügyeleti lehetőség, egyedi vezérlési feladatok, Épületfelügyelet és Energiahatékonyság, PUE től a CO2 ig, hardverfejlesztés'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'energiamenedzsment, energiamérés, almérés, energiamegtakarítás, teljesítménylekötés, épületfelügyelet, mesterséges intelligencia, PUE, integráció, energafelhasználás, AI, hardverfejlesztés energiagazdálkodás, infrastruktúrafelügyelet'
        }
      ],
      __dangerouslyDisableSanitizers: ['meta'],
    },

    extends: DataComponentBase,

    components: {
      AppBarMenu,
      Services,
      Partners,
      Counter,
      Contact,
      Tender,
      Ipsum,
    },

    data: () => ({
      loading: true,
      loaded: false,
      showTender: true,
      dialogTender: null,
    }),

    created() {
    },

    computed: {
      mini() {
        if (this.computedWidth < 800) {
          return true
        } else {
          return false
        }
      }
    },

    methods: {
      openTenderDialog(tender) {
        this.dialogTender = tender;
      },
    }

  }
</script>
<style src="../Style.css">
</style>
